module.exports = __webpack_public_path__ + "static/media/puente-1199.fa6b05b1.webp";